import { render, staticRenderFns } from "./FundPosition.vue?vue&type=template&id=531dfc77&scoped=true"
import script from "./FundPosition.vue?vue&type=script&lang=js"
export * from "./FundPosition.vue?vue&type=script&lang=js"
import style0 from "./FundPosition.vue?vue&type=style&index=0&id=531dfc77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531dfc77",
  null
  
)

export default component.exports